import { render, staticRenderFns } from "./WatchlistAdd.vue?vue&type=template&id=dad3b3b2&"
import script from "./WatchlistAdd.vue?vue&type=script&lang=js&"
export * from "./WatchlistAdd.vue?vue&type=script&lang=js&"
import style0 from "./WatchlistAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dad3b3b2')) {
      api.createRecord('dad3b3b2', component.options)
    } else {
      api.reload('dad3b3b2', component.options)
    }
    module.hot.accept("./WatchlistAdd.vue?vue&type=template&id=dad3b3b2&", function () {
      api.rerender('dad3b3b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/dialog/WatchlistAdd.vue"
export default component.exports